export default __webpack_public_path__ + "fonts/Gotham-Light.22970a6c6243809ba3a36dbbe83f5522.eot";